import styled from "styled-components";

const AboutWinax   = ()=> {
    return (
        <Container>
           <Gallery>
               <Card>
                   <img src="/images/team/team1.jpg" alt = ""/>
               </Card>
               <Card>
                    {/* <img src="/images/gallery/services2.png" alt = ""/> */}
                    <img src="/images/team/group.jpg" alt = ""/>
               </Card>
               <Duration>
                    <h1>3</h1>
                    <p>We have more than 3 years of experience</p>
               </Duration>
           </Gallery>
           <AboutCompany>
                <span>About Company</span>
                <h2>Welcome to Winnthako</h2>   
                <p> A company that provide its client with an easy and flexible financial services.</p>
                <Objectives>
                    <h5>In business, we focus on 3 things.</h5>
                    <ul>
                        <li><span><i class="fa fa-check" aria-hidden="true"></i></span>Reliability</li>
                        <li><span><i class="fa fa-check" aria-hidden="true"></i></span>Credibility</li>
                        <li><span><i class="fa fa-check" aria-hidden="true"></i></span>Accessibility</li>
                    </ul>
                    {/* <ViewBtn>View More</ViewBtn> */}
                </Objectives>
            </AboutCompany> 
        </Container>
    )
}

 const ViewBtn = styled.a`
    background: rgb(231, 60, 62);
    padding: 15px 40px;
    border-radius: 3px;
    cursor: pointer;
    display: inlline-block;
    color: rgb(255,255,255);

 `
 const Container = styled.div`
    padding: 50px 20px;
    display: flex;
    flex-direction: column;

    @media(min-width: 768px){
        padding: 50px;
        flex-direction: row;
        justify-content: space-between;
    }

`
 const Objectives = styled.div`
    h5{
        font-size: 18px;
        font-weight: 400;
    }

    span{
        font-size: 20px;
        padding-right: 10px;
        font-weight: 400;
    }

    ul{
        list-style-type: none;
        padding-left: 0;
    }
`
 const Gallery = styled.div`
    img{
        width: 100%;
    }
     @media(min-width:768px){
            width: 50%;
            position: relative;

             img{
                width: 80%;
                height: 300px;
             }

        div:nth-child(2){
            position: absolute;
            width: 100%;
            top: 20%;
            left: 35%;
        }

        div:nth-child(3){
            position: absolute;
            width: 80%;
            top: 50%;
            left: 20%;
            background: rgb(255, 255, 255);
            border-left: 2px solid rgb(231, 60, 62);
        }
     }

`

const AboutCompany = styled.div`
    span{
        color: rgb(231, 60, 62);
    }
    p{
        color: rgb(96, 96, 96);
        font-size: 15px;
    }
    margin-top: 50px;

    @media(min-width: 768px){
        width: 40%;
        margin: 0;
        h2{
            font-size: 36px;
            line-height: 43.2px;
        }
        p{
            font-size: 16px;
        }
     }
`

const Card = styled.div`
    
`
const Duration = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
    padding: 20px 0;

    h1{
        font-size: 45px;
        margin-bottom: 0;
    }

    @media(min-width: 768px){
        border-left: 2px solid rgb(231, 60, 62);
        flex-direction: row;
        justify-content: center;
        padding: 20px 50px;

        h1{
            font-size: 80px; 
            margin: 0;
        }

        p{
            font-size: 28px;
            line-height: 39.2px;
            color: rgb(17, 17, 17);
            margin-left: 20px;
        }
        
    }

`
export default AboutWinax